import { qs } from '@/lib/api';

export const MAX_SHEET_LABELS = 60;

export function labelSheetRequests(itemIds: string[], copies: number): string[] {
  const requests: string[] = [];
  for (let start = 0; start < itemIds.length; start += MAX_SHEET_LABELS) {
    const chunk = itemIds.slice(start, start + MAX_SHEET_LABELS);
    requests.push(`/lab/labels/print${qs({ itemIds: chunk.join(','), copies: copies > 1 ? copies : undefined })}`);
  }
  return requests;
}

export function labelChunks(itemIds: string[]): string[][] {
  const chunks: string[][] = [];
  for (let start = 0; start < itemIds.length; start += MAX_SHEET_LABELS) chunks.push(itemIds.slice(start, start + MAX_SHEET_LABELS));
  return chunks;
}
